var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPantherSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 459,
    viewBox: "0 0 343 459",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M281.006 49.2724C281.006 49.2724 222.222 88.3775 164.424 143.075C106.628 197.773 36.2745 256.816 36.2745 256.816L20.4636 266.165L-20.8675 300.906L-4.44676 329.634L292.261 75.1785L281.006 49.2724Z",
    fill: "url(#paint0_radial_2486_32758)",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M333.833 164.709C333.833 164.709 277.469 202.205 222.05 254.651C166.633 307.097 99.1745 363.711 99.1745 363.711L58.6953 399.4L36.3711 415.669L47.7857 444.963L344.626 189.549L333.833 164.709Z",
    fill: "url(#paint1_radial_2486_32758)",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M335.418 244.312C335.418 244.312 284.743 278.022 234.921 325.173C185.098 372.324 124.451 423.223 124.451 423.223L110.822 431.282L76.5489 463.198L89.3469 485.995L345.121 266.645L335.418 244.312Z",
    fill: "url(#paint2_radial_2486_32758)",
    fillOpacity: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M365.548 54.1844C365.548 54.1844 202.476 185.21 147.456 237.279C92.4373 289.347 25.4645 345.555 25.4645 345.555L10.414 354.455L-28.1989 389.848L-13.2996 414.874L376.263 78.8454L365.548 54.1844Z",
    fill: "url(#paint3_radial_2486_32758)",
    fillOpacity: 0.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M307.579 264.161L276.127 296.375L272.57 302.948L258.671 312.536L249.499 321.007L246.055 331.453L240.9 334.307L236.67 342.515L228.518 346.432L227.347 358.96L218.595 358.803L210.794 363.247L206.543 375.657L199.358 376.528L196.21 385.564L190.616 383.263L171.106 398.197L166.919 398.005L162.168 399.877L158.234 406.677L148.618 406.547L127.918 420.226L147.097 400.566L152.521 397.058L154.489 393.658L157.811 393.877C157.811 393.877 158.993 388.241 159.639 387.359C160.286 386.477 165.629 381.787 165.629 381.787L165.812 376.505L175.74 367.579L179.736 366.161L180.782 360.852L184.995 360.29L190.41 349.89L194.67 344.372L198.236 344.691L205.743 334.331L218.131 328.665L234.902 311.56L242.894 308.725L245.426 303.261L252.983 298.717C252.983 298.717 259.185 290.554 259.024 291.635C258.863 292.717 261.353 295.655 261.353 295.655L264.128 290.291L272.326 286.558L277.581 282.203L280.964 281.229L285.908 277.195L307.579 264.161Z",
    fill: "url(#paint4_linear_2486_32758)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M315.994 177.261L250.784 220.132L246.455 225.012L241.374 227.023L240.082 231.103L231.905 235.94L225.983 243.753L217.593 244.401L210.53 256.871L201.991 256.944L187.831 271.619L184.406 279.946L178.604 283.71L173.251 283.557L159.241 293.168L151.608 307.965L140.272 312.014L126.354 324.224L123.83 330.361L115.803 335.771L115.021 339.549L110.242 342.708L103.448 351.7L96.985 360.828L94.0374 358.591L90.1014 367.221L83.0665 373.039L80.0608 378.465L73.0563 383.271L73.8089 386.142L58.6869 399.395L80.3036 387.277L84.0025 386.749L87.2478 378.859L94.1339 378.104L101.47 373.435L104.475 368.009L109.257 370.488L117.915 360.725L127.806 354.545L133.186 348.046L139.772 346.143L144.009 338.661L152.788 336.124L156.726 327.493L165.234 322.795L174.554 318.942L179.541 303.056L189.494 300.488L195.865 288.76L204.525 284.634L213.002 275.31L220.339 276.279L222.982 266.091L230.379 265.035L232.242 258.626L237.444 258.203L240.088 248.016L248.717 244.905L254.818 236.652L262.605 233.706L263.475 226.889L275.442 218.487L315.994 177.261Z",
    fill: "#2C3A44"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M212.045 274.048L211.387 273.96L210.748 274.66L202.572 283.625L203.874 283.008L212.045 274.048Z",
    fill: "url(#paint5_linear_2486_32758)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M177.124 302.079L176.731 303.338L172.136 318.047L173.432 317.508L178.062 302.69L178.352 301.761L178.181 301.804L177.124 302.079Z",
    fill: "url(#paint6_linear_2486_32758)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M229.966 257.6L229.554 258.993L228.206 263.559L229.392 263.397L230.884 258.343L231.129 257.514L231.097 257.516L229.966 257.6Z",
    fill: "url(#paint7_linear_2486_32758)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M238.773 247.812L239.005 246.931L238.602 247.07L237.73 247.374L237.443 248.461L235.279 256.654L236.46 256.565L238.773 247.812Z",
    fill: "url(#paint8_linear_2486_32758)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M194.574 287.918L194.931 287.261L194.218 287.599L193.614 287.886L193.245 288.567L187.532 299.07L188.671 298.774L194.574 287.918Z",
    fill: "url(#paint9_linear_2486_32758)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M220.574 265.062L220.193 266.513L218.21 274.048L219.33 274.198L221.522 265.864L221.776 264.9L221.755 264.902L220.574 265.062Z",
    fill: "url(#paint10_linear_2486_32758)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M252.983 236.07L252.687 236.463L247.038 243.963L248.178 243.568L254.016 235.814L254.143 235.647L253.355 235.934L252.983 236.07Z",
    fill: "url(#paint11_linear_2486_32758)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M116.795 281.673L116.947 281.532L117.125 281.431L136.237 270.496L145.028 257.545L145.347 257.075L145.803 256.846L159.479 249.983L168.013 233.96L168.306 233.408L168.778 233.098L182.389 224.143L182.283 224.157L181.953 224.204L181.631 224.415L167.448 233.746L166.977 234.056L166.683 234.609L158.149 250.633L144.474 257.495L144.017 257.724L143.698 258.193L134.907 271.144L115.795 282.079L115.618 282.18L115.465 282.321L101.97 294.763L102.478 294.872L116.795 281.673Z",
    fill: "url(#paint12_linear_2486_32758)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M187.609 222.963L191.649 214.308L191.947 213.67L191.513 213.81L190.737 214.061L190.319 214.957L186.511 223.117L187.609 222.963Z",
    fill: "url(#paint13_linear_2486_32758)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M131.355 347.292L131.034 347.687L125.866 354.041L116.241 360.196L116.055 360.315L115.918 360.471L108.664 368.801L109.197 369.068L117.248 359.823L117.385 359.666L117.571 359.547L127.197 353.392L132.364 347.039L132.418 346.972L131.8 347.158L131.355 347.292Z",
    fill: "url(#paint14_linear_2486_32758)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M160.305 399.57L160.076 399.979L156.897 405.655L157.873 405.639L161.406 399.33L161.566 399.045L160.711 399.401L160.305 399.57Z",
    fill: "url(#paint15_linear_2486_32758)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M197.092 375.496L196.657 376.768L194.546 382.948L195.522 383.338L197.987 376.12L198.251 375.347L198.179 375.357L197.092 375.496Z",
    fill: "url(#paint16_linear_2486_32758)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M102.918 367.228L102.413 368.157L99.6063 373.325L93.6238 377.232L94.0444 377.176L100.936 372.677L103.685 367.613L103.651 367.596L102.918 367.228Z",
    fill: "url(#paint17_linear_2486_32758)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M256.796 311.906L256.693 312L247.463 320.365L247.063 320.727L246.87 321.302L243.655 330.857L239.175 333.29L238.647 333.576L238.319 334.205L234.43 341.676L235.749 341.046L239.648 333.555L239.976 332.926L240.504 332.64L244.983 330.206L248.198 320.65L248.392 320.075L248.791 319.713L258.021 311.348L258.125 311.255L258.207 311.2L271.896 302.014L275.337 295.865L275.453 295.658L275.583 295.527C280.881 290.245 286.204 285.005 291.541 279.785L299.537 271.941C299.89 271.592 300.248 271.251 300.602 270.904C302.483 268.875 304.358 266.832 306.238 264.802C303.562 267.4 300.867 269.968 298.206 272.59L290.21 280.434C284.873 285.653 279.55 290.893 274.252 296.176L274.12 296.307L274.005 296.513L270.563 302.662L256.875 311.849L256.796 311.906Z",
    fill: "url(#paint18_linear_2486_32758)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M225.741 345.837L225.607 347.237L224.678 356.945L225.944 356.968L226.936 346.589L227.07 345.204L226.864 345.302L225.741 345.837Z",
    fill: "url(#paint19_linear_2486_32758)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M217.4 357.49L217.209 357.486L216.832 357.703L209.037 362.17L208.315 362.585L208.013 363.467L204.409 374.061L205.568 373.912L209.343 362.818L209.643 361.936L210.366 361.522L217.4 357.49Z",
    fill: "url(#paint20_linear_2486_32758)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5421 378.774L85.3438 379.275L82.5442 386.355L83.6913 386.166L86.6734 378.627L85.9906 378.716L85.5421 378.774Z",
    fill: "url(#paint21_linear_2486_32758)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5185 342.307L34.2836 342.894L31.8446 349.001L22.2052 354.441L22.0802 354.512L21.991 354.62L14.1689 364.155C14.5792 363.982 14.9882 363.802 15.3986 363.628L23.3212 353.97L23.4103 353.862L23.5353 353.791L33.1747 348.351L35.6138 342.244L35.6591 342.131L35.0363 342.227L34.5185 342.307Z",
    fill: "url(#paint22_linear_2486_32758)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5788 294.165L94.6101 294.123L93.8707 293.964L93.2492 294.813L85.1584 305.863L84.9273 306.179L84.8245 306.541L82.9326 313.208L84.0843 313.185L86.1542 305.893L86.257 305.531L86.488 305.215L94.5788 294.165Z",
    fill: "url(#paint23_linear_2486_32758)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1786 330.294L49.9612 330.689L44.6835 340.292L45.7463 340.127L51.2909 330.041L51.4895 329.679L50.5469 330.12L50.1786 330.294Z",
    fill: "url(#paint24_linear_2486_32758)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8684 314.039L71.4619 314.53L63.6542 323.965L64.9504 323.357L72.6741 314.024L72.4023 314.028L71.8684 314.039Z",
    fill: "url(#paint25_linear_2486_32758)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9751 269.676L34.4884 256.962L33.9103 257.114L33.7482 257.157L33.6221 257.255L16.6449 270.326C10.9809 274.668 6.66322 278.408 1.02354 282.812C3.07762 281.36 3.79366 280.534 5.84643 279.075C9.88584 275.931 13.923 272.783 17.9751 269.676Z",
    fill: "url(#paint26_linear_2486_32758)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2051 215.207L105.799 203.688L106.011 203.32L105.987 203.32L105.054 203.316L104.47 204.336L98.2065 215.278L99.2051 215.207Z",
    fill: "url(#paint27_linear_2486_32758)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M155.432 326.859L155.741 326.175L156.332 325.844L164.238 321.422L163.669 321.659L163.577 321.698L163.499 321.741L155.003 326.493L154.411 326.823L154.102 327.507L150.733 334.978L151.931 334.623L155.432 326.859Z",
    fill: "url(#paint28_linear_2486_32758)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9109 254.181L65.951 239.703L70.1523 234.968L70.2241 234.887L69.3888 235.217L69.0635 235.345L68.8222 235.618L64.6214 240.352L43.3387 254.331L43.9109 254.181Z",
    fill: "url(#paint29_linear_2486_32758)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M189.659 382.176L189.326 382.043L188.715 382.523L170.488 396.797L170.973 396.809L189.659 382.176Z",
    fill: "url(#paint30_linear_2486_32758)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M142.901 337.891L143.122 337.496L142.621 337.645L141.963 337.838L141.571 338.54L137.911 345.066L139.073 344.716L142.901 337.891Z",
    fill: "url(#paint31_linear_2486_32758)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M273.71 218.27L261.769 226.473L261.223 226.848L261.122 227.585L260.355 233.208L261.661 232.73L262.452 226.937L262.553 226.199L263.099 225.825L275.04 217.621C281.804 210.834 288.636 204.156 295.439 197.431C299.082 193.833 302.728 190.24 306.379 186.654C309.143 183.742 311.906 180.831 314.66 177.904C307.785 184.588 300.944 191.33 294.109 198.08C287.307 204.805 280.474 211.484 273.71 218.27Z",
    fill: "url(#paint32_linear_2486_32758)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M225.056 191.531L226.275 191.329L227.473 186.49L227.65 185.772L228.168 185.324L234.218 180.103L238.361 170.091L238.605 169.5L239.068 169.177L254.106 158.683L258.384 151.993L258.579 151.689L258.829 151.508L268.199 144.778L274.408 134.746L274.639 134.372L274.967 134.207L280.676 131.319L286.31 125.053L286.359 124.999L286.399 124.962C296.61 115.549 306.861 106.208 317.12 96.8817L332.501 82.8781L336.449 79.3061L346.584 69.5812L331.172 83.5254L315.791 97.529C305.531 106.855 295.281 116.196 285.07 125.611L285.029 125.647L284.98 125.701L279.347 131.967L273.638 134.856L273.31 135.021L273.078 135.394L266.869 145.427L257.501 152.157L257.25 152.338L257.056 152.642L252.777 159.332L237.739 169.827L237.276 170.15L237.032 170.741L232.889 180.754L226.839 185.974L226.321 186.422L226.144 187.139L225.056 191.531Z",
    fill: "url(#paint33_linear_2486_32758)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M73.778 233.366L75.0623 232.859L76.0836 229.639L76.3152 228.905L76.9291 228.544L84.8001 223.914L90.5266 216.432L90.5661 216.38L90.3513 216.395L89.6863 216.442L89.197 217.081L83.4705 224.563L75.5994 229.193L74.9855 229.553L74.7528 230.287L73.778 233.366Z",
    fill: "url(#paint34_linear_2486_32758)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M144.373 176.382L157.548 167.59L165.045 153.427L165.333 152.882L164.833 153.05L164.134 153.285L163.715 154.076L156.218 168.238L144.039 176.366L144.373 176.382Z",
    fill: "url(#paint35_linear_2486_32758)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M115.205 202.695L128.589 189.049L131.886 181.2L132.19 180.475L132.787 180.098L138.001 176.797L137.716 176.783L137.282 177.058L131.457 180.746L130.861 181.124L130.556 181.849L127.26 189.698L114.514 202.693L115.205 202.695Z",
    fill: "url(#paint36_linear_2486_32758)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M200.778 210.599L217.003 193.301L216.65 193.36L216.148 193.442L215.729 193.89L199.745 210.933L200.778 210.599Z",
    fill: "url(#paint37_linear_2486_32758)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M177.217 148.675L190.637 137.262L193.042 131.655L193.3 131.053L193.768 130.751L201.256 125.938L201.924 122.976L202.103 122.18L202.701 121.803L207.312 118.899L214.001 110.375L220.474 101.579L219.939 101.148L219.309 102.005L212.672 111.024L205.982 119.548L201.371 122.451L200.774 122.829L200.594 123.625L199.926 126.587L192.439 131.4L191.971 131.701L191.713 132.304L189.307 137.912L176.28 148.99L177.217 148.675Z",
    fill: "url(#paint38_linear_2486_32758)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M224.037 102.727L227.553 95.3638L227.688 95.0825L227.892 94.9235L234.897 89.438L237.916 84.277L238.027 84.087L238.173 83.9928L244.407 79.9721L243.81 77.7521C243.984 77.5981 244.156 77.4414 244.33 77.2869L244.31 77.2016L244.229 76.8512L244.504 76.6218C247.122 74.4379 249.747 72.2666 252.376 70.1022C254.438 68.2566 256.506 66.4241 258.566 64.5735C253.427 68.7877 248.289 73.0039 243.174 77.2703L242.9 77.4985L242.981 77.8489L243.55 80.3142L236.843 84.6397L236.696 84.7352L236.585 84.9251L233.567 90.0862L226.561 95.5716L226.357 95.7318L226.222 96.0131L223.3 102.133L224.037 102.727Z",
    fill: "url(#paint39_linear_2486_32758)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M285.917 277.204L280.973 281.238L277.59 282.212L272.334 286.568L264.136 290.301L261.361 295.665C261.361 295.665 258.871 292.728 259.032 291.646C259.193 290.565 252.991 298.727 252.991 298.727L245.434 303.271L242.903 308.735L234.911 311.57L218.139 328.675L205.751 334.341L198.245 344.701L194.678 344.382L190.419 349.9L185.004 360.299L180.791 360.862L179.744 366.171L175.748 367.589L165.82 376.515L165.637 381.797C165.637 381.797 160.295 386.488 159.648 387.369C159.001 388.251 157.82 393.887 157.82 393.887L154.497 393.668L152.529 397.068L147.105 400.576L127.926 420.236L148.626 406.557L158.242 406.686L162.176 399.887L166.928 398.015L171.114 398.206L190.624 383.273L196.218 385.574L199.366 376.538L206.551 375.666L210.802 363.257L218.603 358.813L227.355 358.97L228.527 346.442L236.679 342.525L240.908 334.317L246.064 331.463L249.507 321.017L258.68 312.546L272.578 302.958L276.135 296.385L307.588 264.171L285.917 277.204ZM179.552 303.064L189.504 300.496L195.876 288.768L204.534 284.643L213.012 275.318L220.349 276.286L222.992 266.098L230.39 265.041L232.252 258.633L237.453 258.21L240.096 248.023L248.726 244.911L254.828 236.658L262.615 233.712L263.486 226.895L275.451 218.493L316.004 177.265L250.794 220.137L246.464 225.018L241.383 227.028L240.091 231.109L231.913 235.945L225.991 243.758L217.601 244.407L210.538 256.876L201.998 256.951L187.839 271.625L184.414 279.953L178.61 283.716L173.258 283.564L159.247 293.175L151.613 307.972L140.278 312.021L126.359 324.233L123.835 330.369L115.808 335.779L115.028 339.558L110.247 342.716L103.454 351.708L96.9917 360.837L94.044 358.6L90.1069 367.229L83.072 373.048L80.0663 378.473L73.0619 383.279L73.8145 386.151L58.6935 399.404L80.3108 387.285L84.0096 386.756L87.2549 378.867L94.1405 378.113L101.476 373.444L104.482 368.018L109.264 370.497L117.921 360.734L127.813 354.554L133.194 348.055L139.778 346.151L144.016 338.67L152.795 336.131L156.731 327.502L165.24 322.803L174.56 318.95L179.552 303.064ZM66.5042 240.801L70.871 235.971L75.9598 234.032L77.2891 229.961L85.4942 225.234L91.4785 217.489L99.8541 216.962L107.023 204.568L115.543 204.619L129.812 190.117L133.312 181.82L139.137 178.133L144.476 178.363L158.546 168.935L166.307 154.216L177.655 150.323L191.659 138.288L194.238 132.174L202.299 126.869L203.115 123.093L207.915 119.998L214.78 111.084L221.317 102.029L224.236 104.314L228.248 95.7231L235.323 89.994L238.375 84.5996L245.41 79.8854L244.687 76.9965L259.902 63.9337L231.357 75.4393L227.662 75.9147L224.347 83.7754L217.471 84.4312L210.107 89.0043L207.055 94.3986L202.31 91.8433L193.577 101.503L183.65 107.553L178.219 113.987L171.631 115.799L167.33 123.236L158.546 125.651L154.533 134.243L146 138.829L136.664 142.555L131.533 158.403L121.579 160.832L115.108 172.494L106.43 176.502L97.8812 185.724L90.5712 184.646L87.8339 194.817L80.4441 195.768L78.5232 202.164L73.3296 202.511L70.5924 212.682L61.953 215.675L55.7852 223.857L47.9883 226.696L47.0532 233.515L35.0339 241.762L1.03047 282.817L35.2525 257.371L44.079 255.191L66.5042 240.801ZM102.621 296.7L117.532 283.018L137.054 271.916L146.152 258.576L160.423 251.464L169.34 234.804L183.51 225.43L188.441 224.725L192.968 214.972L201.307 212.252L217.901 194.479L227.323 192.888L228.846 186.681L235.259 181.119L239.586 170.6L254.858 159.8L259.307 152.748L268.887 145.756L275.219 135.379L281.112 132.336L286.883 125.828L347.929 68.945L296.739 101.868L294.846 107.409L288.701 107.615L273.88 118.259L263.036 124.561L255.812 134.914L246.029 133.623L240.82 143.779L230.278 153.109L212.56 163.585L202.818 168.462L196.368 182.891L189.952 180.935L184.019 185.328L180.133 196.028L168.669 206.345L160.811 207.896L152.034 217.951L136.56 227.984L130.79 236.373L119.965 238.24L116.481 250.472L101.728 258.753L95.3966 269.13L85.0129 273.059L83.2112 281.202L73.9112 286.258L64.2909 294.6L60.6852 303.365L50.9044 309.591L45.8963 320.513L39.8816 320.089L34.0706 327.947L-11.0612 374.978L15.5977 364.078L23.694 354.426L33.6752 348.967L36.3197 342.538L46.1826 341.128L52.0736 330.569L65.4233 324.445L73.5196 314.793L84.9065 314.694L87.3901 306.15L95.5252 295.148L102.621 296.7Z",
    fill: "url(#paint40_linear_2486_32758)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M299.563 271.957L291.567 279.801C286.231 285.02 280.907 290.26 275.609 295.543L275.479 295.674L275.363 295.88L271.922 302.029L258.233 311.216L258.151 311.271L258.047 311.364L248.817 319.729L248.418 320.091L248.224 320.666L245.009 330.222L240.53 332.655L240.002 332.942L239.674 333.57L235.775 341.062L228.221 344.666L227.098 345.202L226.965 346.602L225.971 356.981L218.948 356.86L218.56 356.854L218.183 357.07L210.389 361.538L209.666 361.952L209.366 362.835L205.59 373.929L199.523 374.711L198.436 374.851L198.001 376.123L195.536 383.342L191.299 381.651L190.682 381.404L190.07 381.883L170.999 396.819L167.183 396.721L166.974 396.715L166.799 396.788L162.06 398.762L161.654 398.931L161.424 399.34L157.891 405.65L148.763 405.796L148.575 405.798L148.425 405.902L138.169 413.035C134.745 415.397 131.343 417.828 127.933 420.235C131.424 418.083 134.922 415.954 138.398 413.756L148.659 407.324L158.07 407.73L158.567 407.752L158.917 407.166L162.679 400.871L166.859 399.318L170.858 399.583L171.212 399.606L171.577 399.333L190.549 385.144L195.533 387.255L196.883 387.827L197.541 385.971L200.287 378.242L206.404 377.548L207.513 377.422L207.976 376.08L211.946 364.57L218.654 360.771L227.023 360.925L228.762 360.957L228.958 358.803L229.976 347.668L236.993 344.273L237.61 343.975L237.96 343.287L241.847 335.667L246.446 333.074L247.154 332.675L247.427 331.827L250.629 321.909L259.253 313.794L272.967 304.072L273.279 303.851L273.453 303.517L276.832 297.057C281.966 291.655 287.074 286.213 292.169 280.751L299.899 272.488C302.48 269.742 305.028 266.941 307.594 264.168C304.919 266.767 302.224 269.335 299.563 271.957ZM175.682 320.38L176.022 319.302L180.633 304.687L189.535 302.411L190.327 302.209L190.801 301.335L196.801 290.281L204.85 286.427L205.193 286.264L205.47 285.957L213.304 277.312L219.895 278.166L221.36 278.356L221.831 276.512L224.074 267.753L230.278 266.824L231.398 266.656L231.779 265.324L233.219 260.285L237.276 259.928L238.447 259.825L238.806 258.417L241.134 249.281L248.864 246.392L249.303 246.227L249.604 245.815L255.371 237.871L262.751 234.98L263.587 234.653L263.705 233.657L264.429 227.553L275.78 219.408L275.875 219.341L275.944 219.268C282.669 212.342 289.324 205.307 296.009 198.318C302.693 191.326 309.37 184.325 316.012 177.267C309.136 183.951 302.296 190.693 295.461 197.443C288.658 204.167 281.826 210.845 275.062 217.632L263.121 225.836L262.575 226.211L262.474 226.948L261.683 232.742L254.7 235.291L254.328 235.427L254.032 235.82L248.194 243.572L239.968 246.431L239.095 246.734L238.809 247.82L236.497 256.575L232.452 256.876L231.32 256.96L230.908 258.352L229.415 263.406L223.123 264.262L221.942 264.423L221.56 265.874L219.368 274.207L213.485 273.416L212.74 273.316L212.102 274.016L203.896 283.014L195.57 286.961L194.967 287.247L194.597 287.929L188.694 298.784L179.534 301.168L178.477 301.443L178.083 302.701L173.454 317.52L165.027 321.023L164.935 321.061L164.857 321.105L156.361 325.856L155.769 326.188L155.461 326.871L151.959 334.637L143.967 337.001L143.308 337.196L142.915 337.897L139.088 344.723L133.148 346.512L132.703 346.646L132.381 347.042L127.215 353.396L117.589 359.55L117.403 359.669L117.267 359.826L109.215 369.071L104.99 366.957L104.255 366.589L103.75 367.518L100.944 372.686L94.0525 377.186L87.3344 378.067L86.8853 378.127L86.687 378.628L83.7049 386.167L80.3574 386.718L80.2685 386.731L80.1979 386.773C73.0245 390.947 65.8574 395.147 58.7021 399.402C65.9301 395.592 73.1442 391.729 80.3526 387.839L83.9739 387.4L84.3095 387.358L84.4858 386.945L87.6149 379.621L94.0627 379.055L94.2205 379.041L94.3942 378.933L101.76 374.365L102.008 374.211L102.18 373.906L104.697 369.451L108.738 371.621L109.301 371.924L109.863 371.302L118.432 361.811L128.195 355.852L128.401 355.726L128.591 355.501L133.671 349.476L139.841 347.768L140.463 347.596L140.863 346.898L144.722 340.152L152.862 337.854L153.632 337.637L154.046 336.74L157.696 328.827L165.549 324.544L174.793 320.744L175.682 320.38ZM44.2187 256.204L44.3634 256.114L66.8745 242.005L67.0282 241.909L67.1808 241.743L71.3154 237.254L76.113 235.491L76.8286 235.228L77.1275 234.337L78.2362 231.035L85.8721 226.728L86.1669 226.562L86.4131 226.246L91.9216 219.185L99.6411 218.754L100.471 218.708L101.011 217.784L107.633 206.451L115.231 206.516L115.857 206.521L116.399 205.972L130.686 191.5L131.013 191.168L131.207 190.708L134.411 183.143L139.212 180.106L144.108 180.306L144.574 180.325L145.02 180.026L159.08 170.567L159.54 170.256L159.822 169.72L167.151 155.765L177.783 152.042L178.083 151.937L178.336 151.718L192.299 139.595L192.673 139.269L192.868 138.799L195.171 133.243L202.711 128.164L203.339 127.742L203.501 126.963L204.124 123.949L208.285 121.201L208.517 121.048L208.679 120.835L215.447 111.881L221.37 103.525L223.654 105.26L224.46 105.873L224.998 104.694L228.821 96.319L235.612 90.6348L235.764 90.5079L235.851 90.3488L238.736 85.0738L245.56 80.3288L245.945 80.0607L245.83 79.6346L245.148 77.1018C250.081 72.7412 254.993 68.3338 259.904 63.9232C254.765 68.1373 249.627 72.3536 244.512 76.62L244.237 76.8494L244.318 77.1998L244.889 79.6655L238.181 83.9911L238.035 84.0853L237.924 84.2752L234.906 89.4363L227.9 94.9217L227.697 95.0808L227.562 95.362L224.046 102.725L221.931 101.019L221.298 100.507L220.666 101.364L214.029 110.383L207.339 118.907L202.728 121.81L202.131 122.186L201.952 122.984L201.284 125.946L193.797 130.759L193.328 131.06L193.07 131.663L190.664 137.271L177.244 148.684L166.174 152.404L165.475 152.639L165.056 153.431L157.559 167.592L144.385 176.386L139.51 176.164L139.068 176.143L138.634 176.418L132.809 180.106L132.213 180.484L131.908 181.209L128.612 189.058L115.227 202.704L107.336 202.678L106.404 202.675L105.82 203.695L99.2255 215.216L91.6912 215.744L91.0246 215.791L90.5353 216.43L84.8087 223.912L76.9377 228.542L76.3233 228.904L76.0911 229.636L75.0709 232.856L70.7308 234.571L70.4055 234.699L70.1647 234.971L65.964 239.704L43.9239 254.182L35.2499 256.466L35.0878 256.509L34.9611 256.606L17.984 269.676C12.3199 274.019 6.67262 278.407 1.03245 282.812C6.79962 278.736 12.5597 274.642 18.3019 270.502L35.3963 258.234L44.085 256.231L44.2187 256.204ZM102.125 298.376L102.737 298.513L103.316 297.985L118.091 284.492L137.458 273.547L137.846 273.326L138.134 272.906L146.93 260.067L160.761 253.221L161.341 252.934L161.699 252.27L170.351 236.18L183.726 227.283L188.319 226.611L189.271 226.472L189.77 225.392L193.868 216.516L201.42 214.029L201.839 213.891L202.177 213.527L218.327 196.151L227.241 194.618L228.367 194.424L228.696 193.068L230.032 187.569L235.912 182.445L236.291 182.116L236.491 181.626L240.561 171.673L255.321 161.097L255.613 160.889L255.806 160.577L260.035 153.775L269.315 146.896L269.574 146.704L269.744 146.423L275.798 136.356L281.336 133.44L281.546 133.33L281.705 133.148L287.405 126.632C297.525 117.101 307.606 107.498 317.677 97.8803L332.82 83.442L347.929 68.945L332.516 82.8892L317.135 96.8928C306.876 106.219 296.626 115.56 286.415 124.973L286.374 125.01L286.325 125.064L280.692 131.33L274.983 134.218L274.655 134.384L274.423 134.757L268.214 144.789L258.845 151.519L258.594 151.7L258.4 152.004L254.121 158.694L239.084 169.188L238.621 169.511L238.376 170.102L234.234 180.115L228.184 185.335L227.666 185.783L227.488 186.501L226.291 191.341L217.988 192.716L217.487 192.799L217.068 193.246L200.788 210.604L192.859 213.164L192.083 213.415L191.665 214.311L187.625 222.966L183.638 223.524L183.306 223.57L182.985 223.782L168.801 233.112L168.33 233.422L168.036 233.975L159.502 249.999L145.827 256.861L145.37 257.09L145.051 257.561L136.261 270.512L117.15 281.447L116.972 281.549L116.82 281.689L102.503 294.889L96.0187 293.494L95.2092 293.32L94.5872 294.17L86.4968 305.219L86.2653 305.536L86.1625 305.898L84.0926 313.19L73.74 313.387L73.2062 313.397L72.7996 313.888L64.9585 323.364L51.9017 329.488L51.5328 329.66L51.3155 330.055L45.7704 340.143L36.3828 341.588L35.8639 341.668L35.629 342.255L33.19 348.361L23.5505 353.802L23.4255 353.872L23.3364 353.98L15.4138 363.639C6.58371 367.379 -2.24255 371.163 -11.0633 374.979C-2.15216 371.549 6.75439 368.083 15.6556 364.575L15.767 364.531L15.8635 364.417L23.9447 354.995L33.8503 349.747L34.1413 349.593L34.2971 349.224L36.7535 343.423L46.1103 342.19L46.5782 342.128L46.8767 341.602L52.5999 331.494L65.6145 325.656L65.8703 325.541L66.0885 325.284L73.8114 316.201L84.6668 316.219L85.6944 316.22L86.0767 314.937L88.5007 306.786L95.8248 296.978L102.125 298.376Z",
    fill: "#F8FEFF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M298.749 270.642L290.753 278.486C285.417 283.705 280.093 288.945 274.795 294.228L274.664 294.359L274.549 294.566L271.108 300.715L257.419 309.901L257.338 309.956L257.234 310.05L248.004 318.414L247.605 318.776L247.411 319.352L244.196 328.907L239.716 331.34L239.188 331.626L238.86 332.256L234.96 339.747L227.406 343.351L226.283 343.886L226.149 345.287L225.156 355.665L218.132 355.545L217.745 355.538L217.368 355.755L209.574 360.223L208.851 360.637L208.551 361.52L204.775 372.613L198.708 373.396L197.621 373.536L197.186 374.808L194.72 382.026L190.484 380.336L189.866 380.09L189.255 380.569L170.183 395.505L166.367 395.407L166.158 395.401L165.984 395.474L161.244 397.448L160.838 397.617L160.608 398.026L157.075 404.336L147.947 404.482L147.759 404.484L147.609 404.588L137.353 411.721C133.929 414.084 130.527 416.514 127.118 418.922C130.609 416.769 134.107 414.64 137.582 412.444L147.843 406.012L157.255 406.417L157.752 406.44L158.102 405.854L161.864 399.559L166.043 398.007L170.042 398.272L170.396 398.295L170.762 398.022L189.734 383.832L194.718 385.944L196.067 386.516L196.727 384.66L199.473 376.932L205.589 376.237L206.699 376.111L207.161 374.769L211.13 363.258L217.838 359.459L226.207 359.614L227.946 359.646L228.143 357.492L229.16 346.357L236.178 342.961L236.794 342.663L237.145 341.976L241.031 334.356L245.63 331.763L246.338 331.364L246.611 330.516L249.814 320.598L258.437 312.482L272.151 302.76L272.464 302.539L272.638 302.206L276.016 295.746C281.151 290.344 286.258 284.902 291.353 279.44L299.083 271.177C301.664 268.43 304.212 265.629 306.778 262.857C304.105 265.452 301.409 268.019 298.749 270.642ZM174.867 319.065L175.207 317.986L179.818 303.372L188.72 301.096L189.511 300.894L189.986 300.02L195.986 288.966L204.035 285.112L204.378 284.948L204.656 284.642L212.49 275.998L219.081 276.851L220.546 277.041L221.017 275.198L223.26 266.438L229.464 265.509L230.584 265.341L230.965 264.009L232.405 258.971L236.461 258.613L237.632 258.509L237.991 257.102L240.32 247.964L248.049 245.075L248.489 244.911L248.789 244.498L254.557 236.555L261.937 233.664L262.772 233.336L262.89 232.341L263.614 226.236L274.966 218.092L275.06 218.024L275.131 217.952C281.855 211.026 288.511 203.99 295.196 197.002C301.879 190.01 308.556 183.009 315.198 175.951C308.323 182.635 301.482 189.377 294.648 196.128C287.845 202.853 281.013 209.531 274.249 216.318L262.307 224.523L261.762 224.898L261.66 225.635L260.87 231.429L253.886 233.978L253.514 234.114L253.218 234.507L247.381 242.259L239.154 245.119L238.281 245.423L237.995 246.509L235.683 255.263L231.638 255.564L230.506 255.648L230.094 257.041L228.601 262.094L222.309 262.949L221.128 263.11L220.746 264.561L218.554 272.894L212.671 272.103L211.927 272.003L211.288 272.703L203.083 281.701L194.756 285.648L194.152 285.934L193.782 286.615L187.879 297.471L178.719 299.854L177.662 300.13L177.269 301.388L172.64 316.207L164.213 319.71L164.122 319.748L164.044 319.792L155.547 324.543L154.955 324.875L154.647 325.559L151.145 333.325L143.153 335.689L142.495 335.884L142.101 336.585L138.274 343.411L132.334 345.2L131.889 345.334L131.567 345.73L126.401 352.084L116.775 358.238L116.589 358.357L116.453 358.514L108.401 367.759L104.176 365.645L103.441 365.277L102.936 366.206L100.13 371.374L93.2386 375.874L86.5204 376.756L86.0713 376.815L85.873 377.316L82.8909 384.855L79.5434 385.406L79.4545 385.42L79.3839 385.461C72.211 389.634 65.0434 393.835 57.8881 398.09C65.115 394.28 72.3302 390.417 79.5385 386.528L83.1599 386.088L83.4966 386.047L83.6729 385.634L86.8031 378.31L93.2509 377.744L93.4087 377.73L93.5823 377.622L100.948 373.054L101.196 372.9L101.369 372.595L103.885 368.14L107.926 370.31L108.489 370.613L109.051 369.991L117.621 360.5L127.383 354.541L127.589 354.415L127.779 354.19L132.859 348.165L139.029 346.457L139.651 346.285L140.051 345.587L143.911 338.841L152.05 336.543L152.82 336.326L153.234 335.429L156.884 327.516L164.738 323.233L173.981 319.433L174.867 319.065ZM43.4035 254.889L43.5482 254.799L66.0593 240.69L66.213 240.593L66.3657 240.427L70.5002 235.939L75.2978 234.176L76.0134 233.913L76.3123 233.021L77.4205 229.721L85.0565 225.414L85.3513 225.248L85.597 224.933L91.1055 217.872L98.8255 217.44L99.6553 217.394L100.195 216.47L106.817 205.139L114.416 205.204L115.042 205.209L115.584 204.66L129.87 190.188L130.199 189.856L130.393 189.397L133.596 181.833L138.398 178.795L143.293 178.995L143.76 179.014L144.205 178.715L158.266 169.256L158.726 168.946L159.008 168.409L166.337 154.454L176.968 150.731L177.269 150.626L177.521 150.407L191.484 138.284L191.859 137.958L192.053 137.488L194.357 131.932L201.896 126.854L202.524 126.432L202.686 125.654L203.309 122.639L207.471 119.892L207.702 119.739L207.864 119.525L214.632 110.571L220.555 102.216L222.839 103.951L223.645 104.563L224.183 103.384L228.007 95.01L234.798 89.3258L234.95 89.1989L235.038 89.0397L237.923 83.7652L244.746 79.0198L245.131 78.7517L245.016 78.3255L244.334 75.7928C249.268 71.4322 254.18 67.0248 259.09 62.6141C253.951 66.8283 248.813 71.0446 243.698 75.311L243.423 75.5403L243.504 75.8908L244.075 78.3565L237.368 82.682L237.221 82.7774L237.109 82.9673L234.091 88.1284L227.086 93.6139L226.882 93.7729L226.747 94.0542L223.231 101.417L221.117 99.7109L220.483 99.1991L219.852 100.056L213.214 109.075L206.525 117.599L201.914 120.502L201.317 120.878L201.137 121.676L200.47 124.637L192.983 129.45L192.515 129.752L192.258 130.353L189.852 135.961L176.432 147.374L165.362 151.094L164.663 151.329L164.244 152.121L156.747 166.282L143.573 175.076L138.698 174.854L138.256 174.834L137.822 175.108L131.997 178.796L131.4 179.174L131.096 179.899L127.799 187.748L114.415 201.394L106.524 201.368L105.591 201.365L105.008 202.385L98.4132 213.906L90.8789 214.434L90.2123 214.481L89.723 215.12L83.9976 222.603L76.1265 227.233L75.5121 227.595L75.2799 228.327L74.2597 231.547L69.9197 233.261L69.5943 233.39L69.3535 233.661L65.1528 238.395L43.1122 252.874L34.4383 255.158L34.2761 255.201L34.1505 255.298L17.1734 268.369C11.5093 272.711 5.86204 277.099 0.221868 281.505C5.98795 277.428 11.7491 273.334 17.4913 269.194L34.5852 256.928L43.2751 254.925L43.4035 254.889ZM101.311 297.061L101.923 297.198L102.501 296.67L117.275 283.177L136.642 272.232L137.031 272.011L137.319 271.591L146.115 258.751L159.946 251.906L160.526 251.618L160.883 250.955L169.535 234.865L182.911 225.967L187.504 225.296L188.456 225.157L188.954 224.077L193.053 215.201L200.605 212.713L201.024 212.576L201.362 212.212L217.512 194.836L226.426 193.303L227.552 193.109L227.88 191.753L229.217 186.253L235.097 181.13L235.476 180.8L235.676 180.31L239.746 170.358L254.506 159.782L254.797 159.574L254.991 159.262L259.22 152.46L268.5 145.581L268.759 145.389L268.928 145.108L274.983 135.041L280.521 132.125L280.731 132.015L280.89 131.833L286.59 125.317C296.71 115.786 306.79 106.183 316.862 96.5651L332.003 82.1263L347.113 67.6293L331.7 81.5735L316.319 95.5771C306.06 104.903 295.809 114.244 285.598 123.659L285.557 123.695L285.508 123.749L279.875 130.016L274.166 132.904L273.838 133.069L273.607 133.443L267.398 143.475L258.029 150.205L257.779 150.386L257.584 150.69L253.305 157.38L238.268 167.875L237.805 168.198L237.56 168.79L233.417 178.802L227.368 184.022L226.85 184.47L226.672 185.188L225.475 190.028L217.172 191.403L216.671 191.486L216.251 191.934L199.972 209.291L192.043 211.852L191.267 212.102L190.848 212.998L186.808 221.654L182.822 222.21L182.491 222.256L182.17 222.468L167.986 231.798L167.514 232.108L167.22 232.661L158.686 248.685L145.011 255.547L144.555 255.776L144.236 256.247L135.445 269.198L116.333 280.133L116.156 280.234L116.003 280.375L101.686 293.574L95.2019 292.18L94.3924 292.005L93.7704 292.855L85.6801 303.904L85.4474 304.221L85.3446 304.583L83.2747 311.875L72.9222 312.072L72.3883 312.082L71.9817 312.573L64.1406 322.049L51.0839 328.173L50.7149 328.346L50.4976 328.74L44.9536 338.829L35.566 340.274L35.0471 340.354L34.8133 340.941L32.3748 347.046L22.7353 352.487L22.6103 352.557L22.5223 352.666L14.5997 362.324C5.76854 366.064 -3.05665 369.848 -11.8774 373.665C-2.96577 370.233 5.9403 366.769 14.8415 363.26L14.953 363.216L15.0494 363.103L23.1306 353.681L33.0362 348.433L33.3272 348.279L33.483 347.909L35.9394 342.109L45.2962 340.875L45.763 340.813L46.0616 340.286L51.7847 330.179L64.7993 324.341L65.0552 324.226L65.2734 323.969L72.9962 314.886L83.8516 314.904L84.8793 314.905L85.2615 313.621L87.6866 305.472L95.0107 295.664L101.311 297.061Z",
    fill: "url(#paint41_radial_2486_32758)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1854 328.227L39.998 320.368L46.0116 320.792L51.0197 309.87L60.8005 303.644L64.4067 294.877L74.027 286.536L83.327 281.479L85.1287 273.337L95.5119 269.409L101.844 259.031L116.596 250.75L120.081 238.518L130.905 236.651L136.676 228.262L152.15 218.228L160.927 208.173L168.785 206.622L180.249 196.306L184.135 185.606L190.068 181.213L196.483 183.168L202.934 168.74L212.675 163.864L230.394 153.387L240.936 144.058L246.145 133.901L255.929 135.192L263.152 124.84L273.995 118.538L288.818 107.894L294.961 107.689L296.854 102.147L338.586 75.3068L346.52 67.9148L295.33 100.837L293.438 106.379L287.294 106.584L272.472 117.228L261.628 123.53L254.405 133.882L244.621 132.591L239.412 142.748L228.87 152.077L211.151 162.554L201.41 167.429L194.959 181.858L188.544 179.902L182.611 184.295L178.725 194.996L167.261 205.312L159.403 206.863L150.625 216.918L135.152 226.952L129.381 235.34L118.556 237.208L115.072 249.44L100.32 257.72L93.9878 268.099L83.6057 272.027L81.8029 280.169L72.5029 285.226L62.8837 293.568L59.2775 302.334L49.4967 308.56L44.4875 319.481L38.4739 319.058L32.6624 326.917L-11.0885 374.972L-7.89338 372.077L34.1854 328.227Z",
    fill: "url(#paint42_linear_2486_32758)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1669 242.053L47.1862 233.806L48.1214 226.987L55.9183 224.148L62.0872 215.966L70.7254 212.972L73.4631 202.8L78.6567 202.453L80.5776 196.058L87.9675 195.107L90.7041 184.934L98.0142 186.012L106.563 176.79L115.241 172.781L121.712 161.12L131.667 158.691L136.798 142.843L146.134 139.117L154.668 134.531L158.68 125.94L167.463 123.523L171.765 116.088L178.352 114.275L183.784 107.841L193.711 101.791L202.444 92.1315L207.19 94.6873L210.242 89.293L217.606 84.7198L224.482 84.0641L227.797 76.2034L231.492 75.728L254.289 66.5401L258.513 62.912L229.968 74.4177L226.273 74.8931L222.958 82.7538L216.082 83.4096L208.718 87.9827L205.666 93.3771L200.921 90.8217L192.187 100.481L182.26 106.531L176.829 112.965L170.241 114.778L165.94 122.214L157.156 124.63L153.143 133.221L144.61 137.807L135.274 141.533L130.143 157.381L120.189 159.81L113.717 171.471L105.039 175.48L96.4901 184.701L89.18 183.624L86.4434 193.796L79.0536 194.747L77.1327 201.143L71.9391 201.49L69.2024 211.663L60.5631 214.656L54.3953 222.838L46.5973 225.676L45.6622 232.495L33.6428 240.743L1.02569 282.821L6.43441 276.749L35.1669 242.053Z",
    fill: "url(#paint43_linear_2486_32758)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M262.757 289.272L260.198 294.218C260.826 295.139 261.506 295.945 261.506 295.945L264.281 290.582L272.479 286.849L277.734 282.494L281.117 281.52L286.061 277.486L300.945 268.536L306.21 263.144L284.536 276.177L279.593 280.211L276.209 281.185L270.954 285.541L262.757 289.272Z",
    fill: "url(#paint44_linear_2486_32758)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M147.227 400.854L152.651 397.346L154.619 393.946L157.941 394.165C157.941 394.165 159.123 388.529 159.769 387.647C160.416 386.765 165.759 382.075 165.759 382.075L165.942 376.793L175.87 367.866L179.866 366.448L180.912 361.14L185.125 360.577L190.54 350.178L194.801 344.66L198.367 344.98L205.874 334.619L218.262 328.953L235.034 311.848L243.026 309.013L245.557 303.55L253.114 299.005C253.114 299.005 256.738 294.236 258.371 292.478C257.922 291.764 257.567 291.044 257.631 290.614C257.792 289.533 251.59 297.696 251.59 297.696L244.032 302.24L241.501 307.704L233.509 310.539L216.737 327.644L204.349 333.31L196.843 343.671L193.277 343.351L189.017 348.869L183.601 359.268L179.388 359.831L178.341 365.14L174.345 366.559L164.416 375.485L164.235 380.767C164.235 380.767 158.893 385.458 158.245 386.339C157.599 387.221 156.417 392.857 156.417 392.857L153.095 392.638L151.127 396.038L145.703 399.546L128.079 420.06L134.408 413.997L147.227 400.854Z",
    fill: "url(#paint45_linear_2486_32758)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M73.944 386.428L73.1914 383.556L80.1958 378.751L83.2015 373.325L90.2365 367.507L94.1725 358.877L97.1201 361.114L103.583 351.985L110.377 342.993L115.156 339.835L115.938 336.057L123.965 330.646L126.489 324.51L140.407 312.3L151.743 308.251L159.376 293.454L173.387 283.842L178.739 283.995L184.541 280.232L187.966 271.905L202.126 257.23L210.666 257.155L217.728 244.687L226.118 244.038L232.04 236.225L240.217 231.389L241.509 227.308L246.59 225.298L250.919 220.418L308.169 182.779L314.605 176.236L249.395 219.108L245.067 223.988L239.985 225.998L238.693 230.079L230.516 234.915L224.594 242.728L216.204 243.377L209.142 255.845L200.602 255.92L186.442 270.594L183.017 278.922L177.215 282.685L171.862 282.533L157.852 292.144L150.219 306.94L138.883 310.99L124.965 323.2L122.441 329.336L114.414 334.746L113.632 338.525L108.853 341.683L102.059 350.675L95.5971 359.804L92.6484 357.567L88.7124 366.196L81.6775 372.015L78.6718 377.441L71.6674 382.246L72.4199 385.118L58.6788 399.395L65.6754 393.675L73.944 386.428Z",
    fill: "url(#paint46_linear_2486_32758)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2486_32758",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -12,
    y: 63,
    width: 360,
    height: 358
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M307.571 264.169L276.119 296.383L272.562 302.955L258.664 312.544L249.491 321.015L246.048 331.461L240.892 334.315L236.663 342.523L228.511 346.44L227.339 358.968L218.587 358.811L210.786 363.255L206.535 375.664L199.35 376.536L196.202 385.572L190.608 383.271L171.098 398.204L166.912 398.013L162.16 399.885L158.226 406.684L148.61 406.555L127.91 420.234L147.089 400.574L152.513 397.066L154.481 393.666L157.803 393.885C157.803 393.885 158.985 388.249 159.631 387.367C160.278 386.485 165.621 381.795 165.621 381.795L165.804 376.513L175.732 367.587L179.728 366.168L180.775 360.86L184.988 360.297L190.402 349.898L194.662 344.38L198.229 344.699L205.735 334.339L218.123 328.672L234.895 311.567L242.887 308.733L245.418 303.269L252.975 298.725C252.975 298.725 259.178 290.562 259.017 291.643C258.856 292.725 261.345 295.663 261.345 295.663L264.12 290.299L272.318 286.566L277.573 282.211L280.956 281.237L285.9 277.203L307.571 264.169Z",
    fill: "#2C3A44"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M315.982 177.269L250.772 220.14L246.443 225.02L241.362 227.03L240.07 231.111L231.893 235.947L225.971 243.76L217.581 244.409L210.518 256.878L201.979 256.952L187.82 271.627L184.394 279.954L178.592 283.718L173.24 283.565L159.229 293.176L151.596 307.973L140.26 312.022L126.342 324.232L123.818 330.368L115.791 335.779L115.009 339.557L110.23 342.716L103.436 351.708L96.9733 360.836L94.0257 358.599L90.0896 367.229L83.0547 373.047L80.049 378.473L73.0446 383.278L73.7972 386.15L58.6751 399.403L80.2919 387.285L83.9908 386.757L87.2361 378.867L94.1221 378.112L101.458 373.443L104.464 368.017L109.246 370.496L117.903 360.733L127.794 354.553L133.174 348.054L139.76 346.15L143.997 338.669L152.777 336.132L156.714 327.501L165.222 322.802L174.543 318.95L179.529 303.064L189.483 300.496L195.853 288.768L204.513 284.642L212.99 275.318L220.327 276.286L222.97 266.099L230.367 265.043L232.23 258.634L237.432 258.211L240.076 248.024L248.705 244.913L254.806 236.66L262.593 233.714L263.463 226.897L275.43 218.495L315.982 177.269Z",
    fill: "url(#paint47_linear_2486_32758)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M1.02205 282.822L35.2436 257.377L44.0701 255.197L66.4958 240.805L70.861 235.976L75.9503 234.036L77.2796 229.965L85.4847 225.238L91.469 217.493L99.8446 216.966L107.013 204.571L115.533 204.621L129.801 190.12L133.301 181.823L139.127 178.137L144.465 178.367L158.535 168.938L166.295 154.219L177.644 150.327L191.649 138.291L194.227 132.179L202.288 126.874L203.104 123.098L207.904 120.001L214.769 111.088L221.306 102.034L224.224 104.319L228.236 95.7273L235.311 89.9982L238.363 84.6039L245.397 79.8896L244.675 76.9996L259.891 63.9367L231.345 75.4424L227.65 75.9178L224.335 83.7785L217.459 84.4342L210.095 89.0073L207.044 94.4017L202.297 91.8459L193.565 101.505L183.637 107.555L178.205 113.99L171.618 115.803L167.316 123.238L158.533 125.654L154.521 134.246L145.987 138.832L136.652 142.557L131.52 158.406L121.565 160.834L115.094 172.496L106.416 176.505L97.8674 185.726L90.5573 184.649L87.8207 194.821L80.4308 195.772L78.5099 202.167L73.3163 202.515L70.5786 212.687L61.9403 215.681L55.7714 223.862L47.9745 226.701L47.0394 233.52L35.0201 241.767L1.02205 282.822Z",
    fill: "#2C3A44"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M1.02205 282.822L35.2436 257.377L44.0701 255.197L66.4958 240.805L70.861 235.976L75.9503 234.036L77.2796 229.965L85.4847 225.238L91.469 217.493L99.8446 216.966L107.013 204.571L115.533 204.621L129.801 190.12L133.301 181.823L139.127 178.137L144.465 178.367L158.535 168.938L166.295 154.219L177.644 150.327L191.649 138.291L194.227 132.179L202.288 126.874L203.104 123.098L207.904 120.001L214.769 111.088L221.306 102.034L224.224 104.319L228.236 95.7273L235.311 89.9982L238.363 84.6039L245.397 79.8896L244.675 76.9996L259.891 63.9367L231.345 75.4424L227.65 75.9178L224.335 83.7785L217.459 84.4342L210.095 89.0073L207.044 94.4017L202.297 91.8459L193.565 101.505L183.637 107.555L178.205 113.99L171.618 115.803L167.316 123.238L158.533 125.654L154.521 134.246L145.987 138.832L136.652 142.557L131.52 158.406L121.565 160.834L115.094 172.496L106.416 176.505L97.8674 185.726L90.5573 184.649L87.8207 194.821L80.4308 195.772L78.5099 202.167L73.3163 202.515L70.5786 212.687L61.9403 215.681L55.7714 223.862L47.9745 226.701L47.0394 233.52L35.0201 241.767L1.02205 282.822Z",
    fill: "url(#paint48_linear_2486_32758)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M347.924 68.9473L286.878 125.832L281.107 132.34L275.214 135.382L268.882 145.76L259.301 152.752L254.853 159.805L239.581 170.605L235.254 181.124L228.84 186.685L227.319 192.892L217.897 194.483L201.303 212.256L192.965 214.975L188.437 224.729L183.506 225.433L169.335 234.807L160.419 251.467L146.148 258.58L137.05 271.92L117.528 283.021L102.617 296.702L95.5205 295.15L87.3843 306.152L84.9013 314.697L73.5149 314.796L65.4181 324.448L52.0684 330.573L46.1785 341.132L36.3156 342.542L33.6711 348.971L23.6898 354.43L15.5936 364.082L-11.0653 374.982L34.0654 327.951L39.8769 320.091L45.8911 320.516L50.8997 309.593L60.6805 303.368L64.2862 294.602L73.907 286.259L83.207 281.203L85.0087 273.06L95.3919 269.133L101.724 258.755L116.476 250.474L119.961 238.241L130.785 236.374L136.556 227.986L152.03 217.952L160.807 207.897L168.665 206.346L180.129 196.029L184.015 185.329L189.948 180.936L196.363 182.892L202.814 168.463L212.555 163.588L230.274 153.111L240.816 143.782L246.025 133.624L255.808 134.915L263.032 124.564L273.875 118.262L288.697 107.619L294.841 107.413L296.734 101.87L347.924 68.9473Z",
    fill: "#2C3A44"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M347.924 68.9473L286.878 125.832L281.107 132.34L275.214 135.382L268.882 145.76L259.301 152.752L254.853 159.805L239.581 170.605L235.254 181.124L228.84 186.685L227.319 192.892L217.897 194.483L201.303 212.256L192.965 214.975L188.437 224.729L183.506 225.433L169.335 234.807L160.419 251.467L146.148 258.58L137.05 271.92L117.528 283.021L102.617 296.702L95.5205 295.15L87.3843 306.152L84.9013 314.697L73.5149 314.796L65.4181 324.448L52.0684 330.573L46.1785 341.132L36.3156 342.542L33.6711 348.971L23.6898 354.43L15.5936 364.082L-11.0653 374.982L34.0654 327.951L39.8769 320.091L45.8911 320.516L50.8997 309.593L60.6805 303.368L64.2862 294.602L73.907 286.259L83.207 281.203L85.0087 273.06L95.3919 269.133L101.724 258.755L116.476 250.474L119.961 238.241L130.785 236.374L136.556 227.986L152.03 217.952L160.807 207.897L168.665 206.346L180.129 196.029L184.015 185.329L189.948 180.936L196.363 182.892L202.814 168.463L212.555 163.588L230.274 153.111L240.816 143.782L246.025 133.624L255.808 134.915L263.032 124.564L273.875 118.262L288.697 107.619L294.841 107.413L296.734 101.87L347.924 68.9473Z",
    fill: "url(#paint49_linear_2486_32758)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2486_32758)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddn_2486_32758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.184 300.004C267.658 371.784 185.532 406.038 113.752 376.511C41.9717 346.985 7.71816 264.859 37.2446 193.079C66.7711 121.299 148.896 87.0453 220.677 116.572C292.457 146.098 326.711 228.224 297.184 300.004Z",
    fill: "#EEBB4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.184 300.004C267.658 371.784 185.532 406.038 113.752 376.511C41.9717 346.985 7.71816 264.859 37.2446 193.079C66.7711 121.299 148.896 87.0453 220.677 116.572C292.457 146.098 326.711 228.224 297.184 300.004Z",
    fill: "#EEBB4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.721 121.166C237.38 124.53 243.669 128.37 249.563 132.623L246.229 137.245C252.006 141.414 257.387 145.998 262.348 150.939L266.369 146.9C271.613 152.123 276.406 157.726 280.72 163.645L276.115 167.003C280.286 172.725 283.991 178.756 287.204 185.03L292.276 182.431C295.631 188.984 298.47 195.791 300.765 202.787L295.351 204.564C297.549 211.261 299.227 218.137 300.358 225.127L305.983 224.216C307.153 231.446 307.763 238.794 307.784 246.195L302.085 246.213C302.105 253.214 301.577 260.263 300.474 267.302L306.104 268.183C304.979 275.364 303.282 282.534 300.987 289.634L295.563 287.88C294.485 291.216 293.269 294.537 291.912 297.835C290.555 301.134 289.082 304.349 287.502 307.478L292.589 310.047C289.225 316.707 285.386 322.996 281.132 328.89L276.511 325.556C272.342 331.333 267.758 336.714 262.818 341.675L266.855 345.696C261.632 350.94 256.029 355.732 250.109 360.047L246.753 355.442C241.031 359.613 235.001 363.318 228.726 366.531L231.323 371.602C224.771 374.957 217.964 377.797 210.969 380.092L209.193 374.678C202.495 376.876 195.619 378.554 188.629 379.685L189.54 385.31C182.309 386.48 174.96 387.09 167.559 387.111L167.543 381.413C160.542 381.433 153.493 380.904 146.454 379.801L145.572 385.431C138.391 384.305 131.221 382.609 124.121 380.313L125.876 374.891C122.54 373.812 119.22 372.596 115.921 371.239C112.622 369.882 109.407 368.41 106.278 366.829L103.708 371.916C97.0476 368.552 90.7589 364.712 84.8645 360.459L88.2002 355.838C82.4231 351.67 77.0419 347.085 72.0814 342.145L68.0586 346.182C62.8148 340.959 58.0227 335.356 53.7084 329.436L58.3137 326.08C54.1431 320.358 50.438 314.328 47.2254 308.054L42.153 310.65C38.7977 304.097 35.9578 297.29 33.6624 290.295L39.078 288.52C36.8803 281.822 35.2023 274.946 34.071 267.957L28.4446 268.866C27.2743 261.635 26.6655 254.287 26.6445 246.886L32.3436 246.87C32.3236 239.87 32.8524 232.82 33.9551 225.782L28.3247 224.899C29.4498 217.718 31.1463 210.548 33.4418 203.448L38.8656 205.203C39.8093 202.285 40.8586 199.377 42.0152 196.486L42.5171 195.248C43.874 191.949 45.3465 188.734 46.9272 185.605L41.8389 183.035C45.2034 176.375 49.0428 170.086 53.2963 164.191L57.9177 167.527C62.0865 161.75 66.6711 156.369 71.6113 151.409L67.5736 147.386C72.7959 142.142 78.399 137.349 84.3181 133.035L87.6758 137.641C93.3978 133.47 99.4282 129.765 105.702 126.553L103.105 121.479C109.658 118.124 116.464 115.285 123.459 112.99L125.236 118.405C131.934 116.208 138.81 114.53 145.799 113.398L144.889 107.772C152.119 106.601 159.467 105.992 166.868 105.971L166.886 111.671C173.887 111.651 180.936 112.18 187.974 113.282L188.856 107.651C196.037 108.776 203.207 110.473 210.307 112.769L208.553 118.193C211.889 119.271 215.209 120.487 218.508 121.844C221.807 123.201 225.022 124.674 228.151 126.254L230.721 121.166Z",
    stroke: "#FFEBB2",
    strokeWidth: 11.4025,
    strokeDasharray: "22.81 22.81"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_iin_2486_32758)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 167.2,
    cy: 246.545,
    r: 129.133,
    transform: "rotate(-157.64 167.2 246.545)",
    fill: "#005754"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.2,
    cy: 246.545,
    r: 129.133,
    transform: "rotate(-157.64 167.2 246.545)",
    fill: "url(#paint50_linear_2486_32758)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_in_2486_32758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.732 261.98L98.4492 241.296L112.885 206.202L175.831 232.094L161.395 267.189L219.787 291.208L236.025 251.732",
    stroke: "#EBBD6A",
    strokeWidth: 9.43929
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddn_2486_32758",
    x: 21.0344,
    y: 104.068,
    width: 291.791,
    height: 291.791,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.760168,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2486_32758"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.285063,
    dy: 3.42075
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.2805
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2486_32758"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.760168,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_2486_32758"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.285063,
    dy: 1.14025
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.570126
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2486_32758",
    result: "effect2_dropShadow_2486_32758"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "3.5079972743988037 3.5079972743988037",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 2402
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(0, 0, 0, 0.08)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect3_noise_2486_32758"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  })), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "effect3_noise_2486_32758",
    in2: "effect2_dropShadow_2486_32758",
    result: "effect3_noise_2486_32758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_iin_2486_32758",
    x: 38.0312,
    y: 115.094,
    width: 259.191,
    height: 264.037,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.855189,
    dy: 3.42075
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.42075
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2486_32758"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2.2805
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.42075
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2486_32758",
    result: "effect2_innerShadow_2486_32758"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "3.5079972743988037 3.5079972743988037",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 1911
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "effect2_innerShadow_2486_32758",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(255, 190, 0, 0.2)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect3_noise_2486_32758"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "effect2_innerShadow_2486_32758"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_in_2486_32758",
    x: 92.2891,
    y: 200.039,
    width: 148.102,
    height: 97.8983,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.570126
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.24002
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2486_32758"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "3.5079972743988037 3.5079972743988037",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 1911
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "effect1_innerShadow_2486_32758",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(179, 40, 33, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect2_noise_2486_32758"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "effect1_innerShadow_2486_32758"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2486_32758",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(136.424 167.784) rotate(-39.8085) scale(200.458 21.5269)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9325,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2486_32758",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(185.507 286.865) rotate(-41.1095) scale(199.319 21.1376)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9325,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2486_32758",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(223.549 335.233) rotate(-42.6479) scale(173.539 18.1497)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9325,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2486_32758",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(176.757 213.296) rotate(-41.0296) scale(262.359 27.869)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9325,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2486_32758",
    x1: 208.798,
    y1: 323.69,
    x2: 221.038,
    y2: 344.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2486_32758",
    x1: 204.943,
    y1: 277.863,
    x2: 209.675,
    y2: 279.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2486_32758",
    x1: 174.1,
    y1: 309.433,
    x2: 176.369,
    y2: 310.366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2486_32758",
    x1: 228.89,
    y1: 260.216,
    x2: 230.438,
    y2: 260.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2486_32758",
    x1: 236.09,
    y1: 251.36,
    x2: 238.238,
    y2: 252.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2486_32758",
    x1: 190.145,
    y1: 292.719,
    x2: 192.319,
    y2: 293.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2486_32758",
    x1: 218.938,
    y1: 269.039,
    x2: 221.088,
    y2: 269.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2486_32758",
    x1: 249.016,
    y1: 239.157,
    x2: 252.166,
    y2: 240.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2486_32758",
    x1: 120.212,
    y1: 250.417,
    x2: 164.148,
    y2: 268.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2486_32758",
    x1: 188.566,
    y1: 218.121,
    x2: 189.892,
    y2: 218.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2486_32758",
    x1: 114.214,
    y1: 355.308,
    x2: 126.851,
    y2: 360.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2486_32758",
    x1: 158.398,
    y1: 402.007,
    x2: 160.065,
    y2: 402.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2486_32758",
    x1: 195.707,
    y1: 378.863,
    x2: 197.123,
    y2: 379.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2486_32758",
    x1: 96.0558,
    y1: 371.319,
    x2: 101.278,
    y2: 373.467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2486_32758",
    x1: 253.148,
    y1: 296.174,
    x2: 287.52,
    y2: 310.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2486_32758",
    x1: 223.918,
    y1: 350.27,
    x2: 228.007,
    y2: 351.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2486_32758",
    x1: 207.566,
    y1: 364.403,
    x2: 213.546,
    y2: 366.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2486_32758",
    x1: 84.0999,
    y1: 382.281,
    x2: 85.1176,
    y2: 382.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2486_32758",
    x1: 19.5983,
    y1: 350.957,
    x2: 30.2936,
    y2: 355.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2486_32758",
    x1: 86.368,
    y1: 302.677,
    x2: 90.4075,
    y2: 304.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2486_32758",
    x1: 47.0429,
    y1: 334.556,
    x2: 49.1302,
    y2: 335.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2486_32758",
    x1: 66.0561,
    y1: 318.127,
    x2: 70.2725,
    y2: 319.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2486_32758",
    x1: 7.99245,
    y1: 265.871,
    x2: 27.5205,
    y2: 273.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2486_32758",
    x1: 100.875,
    y1: 208.791,
    x2: 103.342,
    y2: 209.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2486_32758",
    x1: 154.095,
    y1: 326.805,
    x2: 160.877,
    y2: 329.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2486_32758",
    x1: 48.7051,
    y1: 241.287,
    x2: 64.8585,
    y2: 247.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2486_32758",
    x1: 174.447,
    y1: 387.172,
    x2: 185.7,
    y2: 391.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2486_32758",
    x1: 139.619,
    y1: 340.912,
    x2: 141.413,
    y2: 341.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2486_32758",
    x1: 272.518,
    y1: 199.39,
    x2: 301.002,
    y2: 211.107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2486_32758",
    x1: 254.585,
    y1: 117.708,
    x2: 316.338,
    y2: 143.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2486_32758",
    x1: 77.6726,
    y1: 223.022,
    x2: 86.3637,
    y2: 226.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2486_32758",
    x1: 149.711,
    y1: 162.578,
    x2: 159.661,
    y2: 166.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2486_32758",
    x1: 120.769,
    y1: 187.487,
    x2: 131.746,
    y2: 192.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2486_32758",
    x1: 204.095,
    y1: 200.357,
    x2: 212.652,
    y2: 203.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2486_32758",
    x1: 187.855,
    y1: 120.851,
    x2: 208.974,
    y2: 129.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2486_32758",
    x1: 232.408,
    y1: 79.9921,
    x2: 249.355,
    y2: 86.9632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2486_32758",
    x1: 83.0024,
    y1: 396.053,
    x2: 299.646,
    y2: 46.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_2486_32758",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(173.674 223.134) rotate(22.3596) scale(166.84 183.036)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9325,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2486_32758",
    x1: 103.93,
    y1: 335.241,
    x2: 229.051,
    y2: 124.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2486_32758",
    x1: 55.9379,
    y1: 304.587,
    x2: 181.062,
    y2: 93.5238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2486_32758",
    x1: 213.04,
    y1: 403.668,
    x2: 337.806,
    y2: 193.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2486_32758",
    x1: 178.066,
    y1: 383.308,
    x2: 303.377,
    y2: 171.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2486_32758",
    x1: 145.107,
    y1: 361.916,
    x2: 270.272,
    y2: 150.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2486_32758",
    x1: 174.515,
    y1: 266.27,
    x2: 210.728,
    y2: 306.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.515183,
    stopColor: "#565656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2486_32758",
    x1: 120.353,
    y1: 155.67,
    x2: 133.771,
    y2: 175.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_2486_32758",
    x1: 155.702,
    y1: 199.963,
    x2: 178.909,
    y2: 233.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D262D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5437,
    stopColor: "#1D262D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2486_32758",
    x1: 234.52,
    y1: 132.683,
    x2: 106.12,
    y2: 369.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.129808,
    stopColor: "#E39934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.513763,
    stopColor: "#FFF3C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966346,
    stopColor: "#EEBB4C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPantherSlash);
export default __webpack_public_path__ + "static/media/panther-slash.4a45d6dab08ffb121e03e18b30c64400.svg";
export { ForwardRef as ReactComponent };